// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-document-detail-tab[data-v-44edcf36]{width:100%;margin-left:auto;margin-right:auto}#send-document-detail-tab .checkboxs .register-row[data-v-44edcf36]{width:180px}#send-document-detail-tab .file-name[data-v-44edcf36]{padding:6px 12px}#send-document-detail-tab .preview-btn[data-v-44edcf36]{width:120px;min-width:120px;max-width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
